<shared-draw-bar-menu-for-desktop [search]="search" [registryId]="registryId" [searchTerm]="searchTerm" [pages]="pages"
    [activePageId]="activeId" [scroll]="scroll" [relativeTarget]="relativeTarget" [toggleIcon]="toggleIcon"
    [back]="back" (onBackClick)="handleBackClick($event)" (onSearchToggle)="handleSearchToggle($event)"
    (onPageClick)="handlePageClick($event)" *ngIf="!isMobile">
</shared-draw-bar-menu-for-desktop>

<shared-draw-bar-menu-for-mobile [search]="search" [registryId]="registryId" [searchTerm]="searchTerm" [pages]="pages"
    [activePageId]="activeId" [scroll]="scroll" [relativeTarget]="relativeTarget" [toggleIcon]="toggleIcon"
    [back]="back" (onBackClick)="handleBackClick($event)" (onSearchToggle)="handleSearchToggle($event)"
    (onPageClick)="handlePageClick($event)" *ngIf="isMobile">
</shared-draw-bar-menu-for-mobile>